import { request } from '../util/request'
// 退保申请接口
export function insureCancelApply (data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsureCancelApplyResource/insureCancelApply`,
    method: 'post',
    data,
    loadingConfig
  })
}